/** Detect degraded / R2 fallback catalog mode from API bodies (MINIAPP / R2-067 / 081). */

export interface CatalogDegradedState {
  /** Browse is from R2/fallback (show status, not necessarily block cart) */
  degraded: boolean;
  readOnly: boolean;
  /** Block checkout when commerce.checkout_enabled is false */
  checkoutDisabled: boolean;
  /** Block add-to-cart when commerce.cart_enabled is false */
  cartDisabled: boolean;
  messageUk: string;
  stagingPromCommerce: boolean;
}

const DEFAULT_UK =
  "Каталог тимчасово відкритий у резервному режимі. Замовлення оформлюються після відновлення сервісу.";

export function readCatalogDegradedState(body: unknown): CatalogDegradedState {
  if (!body || typeof body !== "object") {
    return {
      degraded: false,
      readOnly: false,
      checkoutDisabled: false,
      cartDisabled: false,
      messageUk: DEFAULT_UK,
      stagingPromCommerce: false,
    };
  }
  const raw = body as Record<string, unknown>;
  const mode = raw.mode;
  const readOnly = raw.read_only === true;
  const commerce = (raw.commerce ?? {}) as Record<string, unknown>;
  const warning = (raw.warning ?? {}) as Record<string, unknown>;
  const degraded = mode === "fallback" || mode === "degraded_empty";
  const stagingPromCommerce = commerce.staging_prom_commerce === true;
  const cartEnabled = commerce.cart_enabled === true;
  const checkoutEnabled = commerce.checkout_enabled === true;

  // 081: cart/checkout follow commerce gate, not blanket read_only
  const cartDisabled = degraded ? !cartEnabled : commerce.cart_enabled === false;
  const checkoutDisabled = degraded ? !checkoutEnabled : commerce.checkout_enabled === false;

  return {
    degraded,
    readOnly: readOnly || (degraded && !cartEnabled),
    checkoutDisabled,
    cartDisabled,
    messageUk:
      typeof warning.message_uk === "string" && warning.message_uk.trim()
        ? warning.message_uk
        : DEFAULT_UK,
    stagingPromCommerce,
  };
}
